import { render, staticRenderFns } from "./VrainersImage.vue?vue&type=template&id=49a85bfa&scoped=true&"
import script from "./VrainersImage.vue?vue&type=script&lang=js&"
export * from "./VrainersImage.vue?vue&type=script&lang=js&"
import style0 from "./VrainersImage.vue?vue&type=style&index=0&id=49a85bfa&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49a85bfa",
  null
  
)

export default component.exports